var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-weight-medium text-h6 mb-3"},[_vm._v(" "+_vm._s(_vm.$t("forms.add.title"))+" ")]),_c('div',[_c('form-forms',{attrs:{"schema":_vm.schema,"form":_vm.form},on:{"update:schema":function($event){_vm.schema=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }